/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

type Props = {
  k: number;
  onKChange: (k: number) => void;
  onApply: (k: number) => void;
  onClear: () => void;
  btnClassName?: string;
  inputClassName?: string;
  min?: number;
  max?: number;
};

const DEFAULT_BTN =
  'inline-flex items-center gap-1 h-8 px-2 rounded-lg ' +
  'border border-gray-300/60 bg-white text-[12px] leading-none ' +
  'hover:bg-gray-50 active:scale-[0.99] transition ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

const DEFAULT_INPUT =
  'h-8 w-12 text-center border border-gray-300/60 rounded-lg ' +
  'bg-white text-[12px] outline-none';

const KHopFilter: React.FC<Props> = ({
  k,
  onKChange,
  onApply,
  onClear,
  btnClassName = DEFAULT_BTN,
  inputClassName = DEFAULT_INPUT,
  min = 1,
  max = 6,
}) => {
  const clamp = (val: number) => Math.max(min, Math.min(max, val));
  return (
    <div className='inline-flex gap-1 p-1 bg-white/80 backdrop-blur rounded-lg border border-gray-200 shadow-sm'>
      <input
        type="number"
        min={min}
        max={max}
        value={k || ''}
        placeholder="k"
        onChange={(e) => onKChange(clamp(Number(e.target.value) || min))}
        className={inputClassName}
        title="K für K-Hop"
      />
      <button
        className={btnClassName}
        onClick={() => onApply(k || min)}
        title="K-Hop anwenden"
      >
        <span className="e-icons e-filter" />
        K-Hop
      </button>
      <button className={btnClassName} onClick={onClear} title="K-Hop zurücksetzen">
        Clear
      </button>
    </div>
  );
};

export default KHopFilter;
